<template>
  <div id="custom_template" class="wrap">
    <div class="header">
      <div class="logo">
        <img src="./assets/images/ehk_logo.png" />
      </div>
    </div>
    <div class="content-wrap">
      <div class="content">
        <br />
        <p>Welcome to the Eaton DC</p>
        <br />
        <p>
          To enjoy complimentary WiFi access,<br />please provide us with the
          following
        </p>
        <br />
        <form v-if="!doc.selected_tos" id="clickAndGoForm">
          <input
            type="hidden"
            name="authenticate"
            id="authenticate"
            value="false"
          />

          <input type="hidden" name="rate_plan" id="rate_plan" value="" />

          <div class="last-name text-wrap">
            <table class="table">
              <tbody>
                <tr v-if="isEmail()">
                  <td>
                    <input
                      type="text"
                      name="last_name"
                      id="last_name"
                      class="text"
                      value=""
                      placeholder="Name"
                      v-model="form.last_name"
                    />
                  </td>
                </tr>
                <tr v-if="isEmail()">
                  <td>
                    <br />
                  </td>
                </tr>
                <tr v-if="isEmail()">
                  <td>
                    <input
                      type="text"
                      name="email_address"
                      id="email_address"
                      class="text"
                      value=""
                      placeholder="Email"
                      v-model="form.email_address"
                    />
                  </td>
                </tr>
                <tr v-if="isAccessCode()">
                  <td>
                    <input
                      type="text"
                      name="access_code"
                      id="access_code"
                      class="text"
                      value=""
                      placeholder="Access Code"
                      v-model="form.access_code"
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <br />
                  </td>
                </tr>
                <tr>
                  <td class="toc-input">
                    <input
                      type="checkbox"
                      name="toc"
                      id="toc"
                      v-model="form.toc"
                    />
                    <label for="toc">
                      I agree to the<br />
                      <a href="#" @click="toggleToc"
                        >Terms and Conditions</a
                      ></label
                    >
                  </td>
                </tr>
                <tr>
                  <td>
                    <br />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="button">
            <input
              type="submit"
              name="continueButton"
              id="continueButton"
              value="Connect"
              @click="emitRegistrationMethodData()"
            />
          </div>
        </form>
        <div class="tos" v-if="doc.selected_tos">
          <div class="content-wrap">
            <div class="content">
              <h3>Terms and Conditions</h3>
              <div class="text-wrap text-wrap-end">
                <div style="color: white">
                  <center>
                    <b
                      >TERMS AND CONDITIONS<br />
                      OF INTERNET USE</b
                    ><br /><br />
                    <b
                      >IMPORTANT! PLEASE READ CAREFULLY BEFORE USING. YOUR USE
                      OF THE SERVICES IS YOUR ACKNOWLEDGMENT AND AGREEMENT THAT
                      YOU AGREE WITH THE TERMS SET FORTH BELOW.</b
                    >
                  </center>
                  <br /><br />
                  <b>ACCEPTANCE OF TERMS THROUGH USE</b><br />
                  By using these services (the "Services"), you agree to all
                  terms, conditions, and notices contained herein. The Hotel
                  reserves the right, in its sole discretion, to terminate your
                  access to all or part of the Services, with or without notice.
                  <br /><br />
                  <b>DISCLAIMER OF WARRANTIES</b><br />
                  ALL MATERIALS, INFORMATION, SOFTWARE, PRODUCTS, AND SERVICES
                  INCLUDED IN OR AVAILABLE BY THE HOTEL ARE PROVIDED "AS IS".
                  THE HOTEL, ITS SUBSIDIARIES, AFFILIATES, OWNER, AND ITS
                  REPRESENTATIVES ACCEPT NO LIABILITY FOR ANY PROBLEMS
                  ASSOCIATED WITH YOUR USE OF THE SERVICES, INCLUDING, BUT NOT
                  LIMITED TO, DAMAGE TO YOUR SOFTWARE, HARDWARE, OR OTHER
                  EQUIPMENT; ANY DELAY IN OPERATION OR TRANSMISSION OF THE
                  SERVICES; ANY COMMUNICATIONS LINE FAILURE, THEFT OR
                  DESTRUCTION; ANY PROBLEMS OR TECHNICAL MALFUNCTION OF ANY
                  TELEPHONE NETWORK OR LINES, COMPUTER ON-LINE SYSTEMS, SERVERS,
                  PROVIDERS, OR COMPUTER EQUIPMENT; OR ANY TRAFFIC CONGESTION OF
                  FAILURE OF THE INTERNET OR ANY WEB SITE. THE SERVICES ARE
                  PROVIDED WITHOUT WARRANTIES OF ANY KIND, EITHER EXPRESS OR
                  IMPLIED, INCLUDING, BUT NOT LIMITED TO, IMPLIED WARRANTIES OF
                  MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, TITLE, OR
                  NONINFRINGEMENT. THE HOTEL, ITS SUBSIDIARIES, AFFILIATES,
                  OWNER, AND ITS REPRESENTATIVES DO NOT WARRANT THAT THE
                  SERVICES ARE ACCURATE, RELIABLE OR CORRECT; THAT THE SERVICES
                  WILL BE UNINTERRUPTED OR AVAILABLE AT ANY PARTICULAR TIME OR
                  LOCATION; THAT THE SERVICES ARE SECURE OR THAT ANY WIRELESS OR
                  WIRED CONNECTION WILL NOT BE ACCESSED, INTERCEPTED, ALTERED OR
                  DESTROYED IN WHOLE OR IN PART BY AN UNAUTHORIZED THIRD PARTY;
                  THAT ANY DATA FILES, PROGRAMS, PROCEDURES OR INFORMATION
                  (INCLUDING YOUR PERSONALLY IDENTIFIABLE INFORMATION)
                  DOWNLOADED, RECORDED, TRANSMITTED OR INPUT THROUGH THE
                  SERVICES WILL BE SECURE OR PROTECTED FROM UNAUTHORIZED ACCESS
                  TO, ALTERATION, DELETION, DEFECT OR DESTRUCTION; THAT ANY
                  DEFECTS OR ERRORS WILL BE CORRECTED; OR THAT THE CONTENT OR
                  SERVICES ARE FREE OF VIRUSES OR OTHER HARMFUL COMPONENTS. SOME
                  JURISDICTIONS DO NOT PERMIT THE EXCLUSION OF CERTAIN
                  WARRANTIES, SO THESE EXCLUSIONS MAY NOT APPLY TO YOU.
                  <br /><br />
                  <b>LIMITATION OF LIABILITY</b><br />
                  UNDER NO CIRCUMSTANCES SHALL THE HOTEL, ITS SUBSIDIARIES,
                  AFFILIATES, OWNER OR ITS REPRESENTATIVES BE LIABLE FOR ANY
                  DIRECT, INDIRECT, PUNITIVE, INCIDENTAL, SPECIAL, OR
                  CONSEQUENTIAL DAMAGES THAT RESULT FROM THE USE OF OR INABILITY
                  TO USE, THE SERVICES. THIS LIMITATION APPLIES EVEN IF THE
                  HOTEL HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGE. SOME
                  JURISDICTIONS DO NOT ALLOW THE EXCLUSION OR LIMITATION OF
                  INCIDENTAL OR CONSEQUENTIAL DAMAGES, SO THE HOTEL'S LIABILITY
                  IN SUCH JURISDICTIONS SHALL BE LIMITED TO THE MAXIMUM EXTENT
                  PERMITTED BY LAW.
                  <br /><br />
                  <b>INDEMNIFICATION</b><br />
                  You shall defend, indemnify and hold the Hotel and its owners,
                  subsidiaries and other affiliated companies, and their
                  employees, contractors, officers, and directors harmless from
                  all liabilities, claims, and expenses, including attorney's
                  fees resulting from your use or misuse of the Services.
                  <br /><br />
                  <b>THIRD PARTY SITES</b><br />
                  Your use of the Services may business center you to other
                  sites on the Internet. These sites may contain information or
                  material that some people may find inappropriate or offensive.
                  These other sites are not under the control of the Hotel, and
                  you acknowledge that the Hotel is not responsible for the
                  accuracy, legality, decency, or any other aspect of the
                  content of such sites. The inclusion of such a business center
                  does not imply endorsement of the site by the Hotel.
                  <br /><br />
                  <b>RULES OF CONDUCT</b><br />
                  You agree not to use these Services for unlawful purposes or
                  in an offensive manner, including, without limitation, usage
                  that (i) is threatening, abusive, harassing, defamatory,
                  libelous, deceptive, fraudulent, invasive of another's
                  privacy, tortious, or (ii) contains language (sexual or
                  otherwise) of a violent or threatening nature directed at
                  another individual or group of individuals, or victimizes,
                  harasses, degrades, or intimidates an individual or group of
                  individuals on the basis of religion, gender, sexual
                  orientation, race, ethnicity, age, or disability. You shall
                  also be prohibited from usage that infringes any patent,
                  trademark, trade secret, copyright, right of publicity, or
                  other proprietary right of any party (collectively,
                  "Intellectual Property"). You shall not introduce any software
                  viruses or any other computer code, files, or programs that
                  are designed or intended to disrupt, damage, or limit the
                  functioning of any software, hardware, or telecommunications
                  equipment or to damage or obtain unauthorized access to any
                  data or other information of any third party. You further
                  agree that you will not knowingly solicit or collect personal
                  information from a minor (anyone under 18 yrs old) without
                  appropriate prior verifiable parental consent. The Hotel makes
                  no representation that materials accessed through the Service
                  are appropriate or available for use in locations outside the
                  United States, and accessing them from territories where their
                  contents are illegal is prohibited.
                  <br /><br />
                  <b>MONITORING</b><br />
                  The Hotel, its subsidiaries, affiliates, owner or its
                  representatives have no obligation to monitor, track, record,
                  store or disclose your use of the Services, including, without
                  limitation, the URLs of the websites you visit and the data
                  you enter, transmit, or receive, but may do so (i) to comply
                  with legal or regulatory requirements or to assist in law
                  enforcement investigations and procedures; (ii) to operate the
                  Services properly; (iii) to ensure compliance with the terms
                  and conditions herein; or (iv) based on a good faith belief
                  that such monitoring, tracking, recording, storing, or
                  disclosure is otherwise necessary or advisable including,
                  without limitation, if there is reason to believe that such
                  information is necessary to identify, contact or bring legal
                  action against someone who may be causing interference with
                  our rights or properties, whether intentionally or otherwise,
                  or when anyone else could be harmed by such activities.
                  <br /><br />
                  <b>PROPRIETARY RIGHTS</b><br />
                  You acknowledge and agree that all content and materials
                  available to you through these Services are protected by
                  Intellectual Property rights and laws. Reproduction, copying,
                  or redistribution for commercial purposes of any materials or
                  design elements obtained through these Services is strictly
                  prohibited without the express written permission of
                  Intellectual Property owner.
                  <br /><br />
                  <b>REVISIONS</b><br />
                  The Hotel reserves the right, in it sole discretion, to update
                  or revise these terms from time to time.
                </div>
                <br /><br />
              </div>
              <div class="button">
                <input
                  type="button"
                  name="back"
                  id="backButton"
                  @click="toggleToc"
                  value="Back"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="clearfix"></div>
  </div>
</template>

<script>
import $ from "jquery";
import RegistrationMethod from "@/components/PortalRegistrationMethod";

export default {
  name: "custom_template",
  props: ["portal", "connection_data"],
  components: {
    "registration-method": RegistrationMethod,
  },
  watch: {
    // Collapse the Terms of Service when registration method changes
    "doc.selected_rm": function () {
      this.doc.selected_tos = null;
    },
    "form.toc": function () {
      if (this.form.toc) {
        document.getElementById("continueButton").disabled = false;
      } else {
        document.getElementById("continueButton").disabled = true;
      }
    },
  },
  data() {
    return {
      form: {
        last_name: "",
        room_number: "",
        email_address: "",
        access_code: "",
        tos: "",
      },
      doc: {
        window_width: window.innerWidth,
        selected_rm: null,
        selected_tos: null,
        selected_inline_image: 0,
        selected_background_image: 0,
        support_phone: "8772822519",
      },
      registration_methods: [],
      // Manually setting this up here because not in endpoint
      terms_of_service: `<center><b>TERMS AND CONDITIONS<br>OF INTERNET USE</b><br><br><b>IMPORTANT! PLEASE READ CAREFULLY BEFORE USING. YOUR USE OF THE SERVICES IS YOUR ACKNOWLEDGMENT AND AGREEMENT THAT YOU AGREE WITH THE TERMS SET FORTH BELOW.</b></center><br><br><b>ACCEPTANCE OF TERMS THROUGH USE</b><br>By using these services (the "Services"), you agree to all terms, conditions, and notices contained herein. The Hotel reserves the right, in its sole discretion, to terminate your access to all or part of the Services, with or without notice.<br><br><b>DISCLAIMER OF WARRANTIES</b><br>ALL MATERIALS, INFORMATION, SOFTWARE, PRODUCTS, AND SERVICES INCLUDED IN OR AVAILABLE BY THE HOTEL ARE PROVIDED "AS IS". THE HOTEL, ITS SUBSIDIARIES, AFFILIATES, OWNER, AND ITS REPRESENTATIVES ACCEPT NO LIABILITY FOR ANY PROBLEMS ASSOCIATED WITH YOUR USE OF THE SERVICES, INCLUDING, BUT NOT LIMITED TO, DAMAGE TO YOUR SOFTWARE, HARDWARE, OR OTHER EQUIPMENT; ANY DELAY IN OPERATION OR TRANSMISSION OF THE SERVICES; ANY COMMUNICATIONS LINE FAILURE, THEFT OR DESTRUCTION; ANY PROBLEMS OR TECHNICAL MALFUNCTION OF ANY TELEPHONE NETWORK OR LINES, COMPUTER ON-LINE SYSTEMS, SERVERS, PROVIDERS, OR COMPUTER EQUIPMENT; OR ANY TRAFFIC CONGESTION OF FAILURE OF THE INTERNET OR ANY WEB SITE. THE SERVICES ARE PROVIDED WITHOUT WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED, INCLUDING, BUT NOT LIMITED TO, IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, TITLE, OR NONINFRINGEMENT. THE HOTEL, ITS SUBSIDIARIES, AFFILIATES, OWNER, AND ITS REPRESENTATIVES DO NOT WARRANT THAT THE SERVICES ARE ACCURATE, RELIABLE OR CORRECT; THAT THE SERVICES WILL BE UNINTERRUPTED OR AVAILABLE AT ANY PARTICULAR TIME OR LOCATION; THAT THE SERVICES ARE SECURE OR THAT ANY WIRELESS OR WIRED CONNECTION WILL NOT BE ACCESSED, INTERCEPTED, ALTERED OR DESTROYED IN WHOLE OR IN PART BY AN UNAUTHORIZED THIRD PARTY; THAT ANY DATA FILES, PROGRAMS, PROCEDURES OR INFORMATION (INCLUDING YOUR PERSONALLY IDENTIFIABLE INFORMATION) DOWNLOADED, RECORDED, TRANSMITTED OR INPUT THROUGH THE SERVICES WILL BE SECURE OR PROTECTED FROM UNAUTHORIZED ACCESS TO, ALTERATION, DELETION, DEFECT OR DESTRUCTION; THAT ANY DEFECTS OR ERRORS WILL BE CORRECTED; OR THAT THE CONTENT OR SERVICES ARE FREE OF VIRUSES OR OTHER HARMFUL COMPONENTS. SOME JURISDICTIONS DO NOT PERMIT THE EXCLUSION OF CERTAIN WARRANTIES, SO THESE EXCLUSIONS MAY NOT APPLY TO YOU.<br><br><b>LIMITATION OF LIABILITY</b><br>UNDER NO CIRCUMSTANCES SHALL THE HOTEL, ITS SUBSIDIARIES, AFFILIATES, OWNER OR ITS REPRESENTATIVES BE LIABLE FOR ANY DIRECT, INDIRECT, PUNITIVE, INCIDENTAL, SPECIAL, OR CONSEQUENTIAL DAMAGES THAT RESULT FROM THE USE OF OR INABILITY TO USE, THE SERVICES. THIS LIMITATION APPLIES EVEN IF THE HOTEL HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGE. SOME JURISDICTIONS DO NOT ALLOW THE EXCLUSION OR LIMITATION OF INCIDENTAL OR CONSEQUENTIAL DAMAGES, SO THE HOTEL'S LIABILITY IN SUCH JURISDICTIONS SHALL BE LIMITED TO THE MAXIMUM EXTENT PERMITTED BY LAW.<br><br><b>INDEMNIFICATION</b><br>You shall defend, indemnify and hold the Hotel and its owners, subsidiaries and other affiliated companies, and their employees, contractors, officers, and directors harmless from all liabilities, claims, and expenses, including attorney's fees resulting from your use or misuse of the Services.<br><br><b>THIRD PARTY SITES</b><br>Your use of the Services may business center you to other sites on the Internet. These sites may contain information or material that some people may find inappropriate or offensive. These other sites are not under the control of the Hotel, and you acknowledge that the Hotel is not responsible for the accuracy, legality, decency, or any other aspect of the content of such sites. The inclusion of such a business center does not imply endorsement of the site by the Hotel.<br><br><b>RULES OF CONDUCT</b><br>You agree not to use these Services for unlawful purposes or in an offensive manner, including, without limitation, usage that (i) is threatening, abusive, harassing, defamatory, libelous, deceptive, fraudulent, invasive of another's privacy, tortious, or (ii) contains language (sexual or otherwise) of a violent or threatening nature directed at another individual or group of individuals, or victimizes, harasses, degrades, or intimidates an individual or group of individuals on the basis of religion, gender, sexual orientation, race, ethnicity, age, or disability. You shall also be prohibited from usage that infringes any patent, trademark, trade secret, copyright, right of publicity, or other proprietary right of any party (collectively, "Intellectual Property"). You shall not introduce any software viruses or any other computer code, files, or programs that are designed or intended to disrupt, damage, or limit the functioning of any software, hardware, or telecommunications equipment or to damage or obtain unauthorized access to any data or other information of any third party. You further agree that you will not knowingly solicit or collect personal information from a minor (anyone under 18 yrs old) without appropriate prior verifiable parental consent. The Hotel makes no representation that materials accessed through the Service are appropriate or available for use in locations outside the United States, and accessing them from territories where their contents are illegal is prohibited.<br><br><b>MONITORING</b><br>The Hotel, its subsidiaries, affiliates, owner or its representatives have no obligation to monitor, track, record, store or disclose your use of the Services, including, without limitation, the URLs of the websites you visit and the data you enter, transmit, or receive, but may do so (i) to comply with legal or regulatory requirements or to assist in law enforcement investigations and procedures; (ii) to operate the Services properly; (iii) to ensure compliance with the terms and conditions herein; or (iv) based on a good faith belief that such monitoring, tracking, recording, storing, or disclosure is otherwise necessary or advisable including, without limitation, if there is reason to believe that such information is necessary to identify, contact or bring legal action against someone who may be causing interference with our rights or properties, whether intentionally or otherwise, or when anyone else could be harmed by such activities.<br><br><b>PROPRIETARY RIGHTS</b><br>You acknowledge and agree that all content and materials available to you through these Services are protected by Intellectual Property rights and laws. Reproduction, copying, or redistribution for commercial purposes of any materials or design elements obtained through these Services is strictly prohibited without the express written permission of Intellectual Property owner.<br><br><b>REVISIONS</b><br>The Hotel reserves the right, in it sole discretion, to update or revise these terms from time to time.`,
    };
  },
  filters: {
    phone: function (value) {
      if (!value) return "";
      value = value.toString();
      return (
        "(" +
        value.substr(0, 3) +
        ") " +
        value.substr(3, 3) +
        "-" +
        value.substr(6, 4)
      );
    },
  },
  mounted() {
    if (this.portal.template.support_phone) {
      this.doc.support_phone = this.portal.template.support_phone;
    }

    this.generateRegistrationMethods();

    $(document).ready(function () {
      if ($("#toc").checked == "true") {
        $("#continueButton").prop("disabled", false);
      } else {
        $("#continueButton").prop("disabled", true);
      }
    });
  },
  methods: {
    generateRegistrationMethods: function () {
      for (var i in this.portal.registration_methods) {
        var rm = this.portal.registration_methods[i];
        for (var c in rm.rate_plans) {
          var rateplan = rm.rate_plans[c];
          var plan = {
            name:
              rm.free == 0 ? rateplan.rate_plan_name : rm.registration_method,
            type: "rateplan",
            registration_method_id: rm.registration_method_id,
            id: rateplan.rateplan_id,
            price: rateplan.price,
            duration: rateplan.duration,
            speed_upload: rateplan.speed_upload,
            speed_download: rateplan.speed_download,
            additional_devices: rateplan.additional_devices,
            terms_of_service: this.terms_of_service,
          };
          this.registration_methods.push(plan);
        }
      }
      if (this.portal.access_codes.length > 0) {
        plan = {
          name: "Access Code",
          type: "accesscode",
          registration_method_id: 4,
          terms_of_service: this.terms_of_service,
        };
        this.registration_methods.push(plan);
      }
      if (this.registration_methods.length == 1) {
        this.doc.selected_rm = 0;
      }
    },
    isEmail: function () {
      if (this.registration_methods[0].registration_method_id == 3) {
        return true;
      } else {
        return false;
      }
    },
    isAccessCode: function () {
      if (this.registration_methods[0].registration_method_id == 4) {
        return true;
      } else {
        return false;
      }
    },
    // Change selected registration method from emitted data
    changeSelected: function (index) {
      this.doc.selected_rm = index;
    },
    toggleToc: function (lang) {
      if (!this.doc.selected_tos) {
        this.doc.selected_tos = true;
      } else {
        this.doc.selected_tos = false;
      }
    },
    // Change selected terms of service from emitted data
    changeSelectedTOS: function (index) {
      this.doc.selected_tos = index;
    },
    // Send registration method details back to parent
    emitRegistrationMethodData: function () {
      // an Eaton DC zone will have either email verification OR access code as a registration method
      // so this first registration method will be the one displayed in the page
      this.registration_method = this.registration_methods[0];

      this.access_code = this.form.access_code;
      // If no access code set, show required text
      if (this.registration_method.type == "accesscode" && !this.access_code) {
        this.access_code_valid = false;
        return;
      }

      var emitted = {
        registration_method_id: this.registration_method.registration_method_id,
        rateplan_id: null,
        email_address: null,
        last_name: null,
        room_number: null,
        access_code: null,
      };

      if (this.registration_method.registration_method_id == "1") {
        emitted.rateplan_id = this.registration_method.id;
      } else if (this.registration_method.registration_method_id == "2") {
        emitted.rateplan_id = this.registration_method.id;
        emitted.last_name = this.form.last_name;
        emitted.room_number = this.form.room_number;
      } else if (this.registration_method.registration_method_id == "3") {
        emitted.rateplan_id = this.registration_method.id;
        emitted.email_address = this.form.email_address;
        emitted.last_name = this.form.last_name;
      } else if (this.registration_method.registration_method_id == "4") {
        emitted.access_code = this.access_code;
      }

      this.$emit("emitRegistrationMethodData", emitted);
    },
  },
};
</script>

<style>
body,
div,
dl,
dt,
dd,
ul,
ol,
li,
h1,
h2,
h3,
h4,
h5,
h6,
pre,
form,
fieldset,
input,
textarea,
p,
blockquote,
th,
td,
img {
  margin: 0;
  padding: 0;
}
table {
  border-collapse: collapse;
  border-spacing: 0;
}
fieldset,
img {
  border: 0;
}
address,
caption,
cite,
code,
dfn,
em,
strong,
th,
var {
  font-style: normal;
  font-weight: normal;
}
ol,
ul {
  list-style: none;
}
caption,
th {
  text-align: left;
}
h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: 100%;
  font-weight: normal;
}
q:before,
q:after {
  content: "";
}
abbr,
acronym {
  border: 0;
}
html,
body,
div,
span,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
pre,
a,
abbr,
address,
cite,
code,
del,
dfn,
em,
img,
ins,
q,
small,
strong,
sub,
sup,
dl,
dt,
dd,
ol,
ul,
li,
fieldset,
form,
label,
legend,
table,
caption,
tbody,
tfoot,
thead,
tr,
th,
td {
  border: 0;
  margin: 0;
  padding: 0;
}
article,
aside,
figure,
figure img,
figcaption,
hgroup,
footer,
header,
nav,
section,
video,
object {
  display: block;
}
a img {
  border: 0;
}
figure {
  position: relative;
}
figure img {
  width: 100%;
}

body {
  width: 100%;
  background: white;
  font-size: 12px;
  line-height: 15px;
  font-family: Arial, sans-serif;
  color: #6b6b6b;
  text-align: center;
}

textarea,
input[type="text"],
input[type="button"],
input[type="submit"] {
  -webkit-appearance: none;
  border-radius: 0;
}

a:link,
a:visited {
  color: #444444;
}
a:hover {
  color: #818181;
}

.loading {
  clear: both;
  float: left;
  width: 100%;
  height: 48px;
  background: url(/images/loading-sm.gif) top center no-repeat transparent;
}

.wrap {
  width: 620px;
  margin: 0 auto 30px;
  padding: 30px 0 0;
  text-align: left;
  background: #fff;
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
  box-shadow: 0px 0px 40px rgba(0, 0, 0, 0.35);
}
.header {
  width: 620px;
  clear: both;
  float: left;
  padding: 10px 0;
  text-align: center;
}

.content-wrap {
  width: 620px;
  clear: both;
  float: left;
}
.content-left,
.content-right {
  width: 450px;
  overflow: hidden;
}
.content-left {
  float: left;
  margin-left: 20px;
}
.content-right {
  float: right;
  margin-right: 20px;
}
.content-left h3,
.content-right h3 {
  margin-left: 0;
  margin-right: 0;
}

.wrap-old {
  width: 620px;
  margin: 30px auto;
  padding: 0 10px;
  text-align: left;
}
.wrap-old .header,
.wrap-old .content-wrap {
  background: #fff;
  border-radius: 6px;
  box-shadow: 0px 0px 40px rgba(0, 0, 0, 0.35);
}
.wrap-old .header {
  padding: 0;
  margin-bottom: 20px;
}
.wrap-old .header .logo {
  float: left;
}
.wrap-old .header .logo img {
  margin: 14px 14px 12px;
}
.wrap-old .header .slogan-wrap {
  float: right;
}
.wrap-old .header .slogan {
  margin: 48px 20px 0 0;
  font-size: 22px;
  text-align: right;
}

.clearfix {
  clear: both;
  height: 1px;
  overflow: hidden;
}

.table {
  width: 100%;
}
.table tr td {
  padding: 2px 5px;
}
.table tr td:first-child {
  width: 90px;
  padding-right: 10px;
}
.label {
  white-space: nowrap;
}

.toc-input {
  text-align: right;
}
.toc-text {
  text-transform: uppercase;
  font-weight: bold;
}

.text-wrap {
  float: left;
  clear: both;
  width: 580px;
  margin: 0 0 20px 0;
  padding: 0 20px;
}
.text-wrap-end {
  margin: 0;
}
.text-wrap p {
  line-height: 1.4em;
}

#rate_plan_td ol {
  padding: 5px 0;
  list-style-type: decimal;
}
#rate_plan_td ol li {
  margin: 0 0 10px 22px;
  font-size: 16px;
}
#rate_plan_td ol li:last-child {
  margin-bottom: 0;
}

.rate-plan {
  display: block;
  width: 580px;
  background: #ebeae6;
  padding: 20px 0;
  margin: 0 auto 20px auto;
  text-align: center;
}
.rate-plan-option {
  cursor: pointer;
}
.rate-plan-option:hover {
  background: #d2e5fa;
}
.rate-plan:last-child {
  margin: 0;
}
.rate-plan .price {
  font-size: 1.1em;
  font-weight: bold;
}
.rate-plan .title {
  font-size: 1.2em;
  font-weight: bold;
}
.rate-plan-selected {
  background: #dcebb2 !important;
  box-shadow: inset 0 0 0 6px rgba(195, 235, 96, 0.7);
}
.rate-plan-selected:hover {
  background: #dcebb2 !important;
}

.rate_plan {
  display: inline-block;
  width: 100%;
  font-size: 16px;
  padding: 10px;
  margin: 0;
  background: #e8e8e8;
  color: #6b6b6b;
  border: 1px solid #e8e8e8;
  text-align: left;
}
.text {
  width: 240px;
  font-size: 16px;
  padding: 10px;
  background: #e8e8e8;
  color: #6b6b6b;
  border: 1px solid #e8e8e8;
  text-align: left;
}
.mini {
  width: 60px;
}

.button {
  display: block;
  float: left;
  clear: both;
  width: 43.5%;
  margin-left: 5%;
  margin-right: 5%;
  font-size: 16px;
}
.button-end {
  margin-top: 20px;
}
.button input {
  width: 100%;
  margin: 0;
  min-height: 36px;
}
.button input {
  min-height: 48px;
  font-size: 16px;
}
.button-small {
  width: 100%;
  margin: 0;
}
.button input.button-half {
  width: 285px;
}
.button input.button-half:last-child {
  float: right;
}
.button input.button-half {
  display: block;
  width: 100%;
}
.button input.button-half:last-child {
  margin-top: 20px;
}

h3 {
  clear: both;
  display: block;
  width: 580px;
  margin: 0 20px 20px 20px;
  padding-top: 20px;
  line-height: 1.5em;
  font-size: 16px;
  font-weight: bold;
  border-bottom: 1px solid #dcdcdc;
}
p {
  margin: auto 10px;
}
.mb0 {
  margin-bottom: 0 !important ;
}
.mt20 {
  margin-top: 20px !important;
}

#table-devices {
  width: 100%;
  margin-top: 20px;
}

#table-devices tr td {
  padding: 3px 5px;
}

#table-devices tbody tr:nth-child(odd) {
  background: #ebeae6;
}

#table-devices thead tr td {
  font-weight: bold;
}

#table-devices tr td.idx {
  width: 10px;
  text-align: center;
}

#table-devices tr td.action {
  width: 10px;
  text-align: center;
  cursor: pointer;
}

#table-upgrade {
  width: 580px;
  margin: 0 20px;
  font-size: 12px;
}

#table-upgrade thead tr td {
  padding: 0 0 5px 0;
  font-weight: bold;
}

#table-upgrade tfoot tr td {
  padding: 5px 0 0 0;
  font-weight: bold;
}

#table-upgrade tr td:last-child {
  text-align: right;
}

#table-upgrade tbody tr td {
  padding: 5px 0;
}

.errors {
  display: block;
  width: 565px;
  margin: 0 20px 20px 20px;
  padding-left: 15px;
  list-style: disc inside;
}
.errors li {
}

.toc-agree {
  clear: both;
  margin: 0 0 10px 0;
  padding: 0 20px;
  font-size: 11px;
  font-weight: bold;
  text-align: left;
  text-transform: uppercase;
}
.toc-agree input {
  margin-right: 5px;
}

.device-info {
  float: left;
  width: 300px;
  margin: 20px 0 10px 20px;
  padding: 10px 0 0 0;
  border-top: 1px solid #dcdcdc;
}

.support-info {
  float: right;
  width: 280px;
  margin: 20px 20px 10px 0;
  padding: 10px 0 0 0;
  border-top: 1px solid #dcdcdc;
  text-align: right;
}

.footer {
  float: left;
  clear: both;
  margin: 20px;
}

#timeRemaining {
  display: block;
  width: 580px;
  height: 30px;
  margin: 0 20px;
  padding: 25px 0 20px;
}
#upgradeButton {
  cursor: pointer;
}

/* jQuery Countdown styles 1.6.1. */
.hasCountdown {
  background-color: #ebeae6;
}
.countdown_rtl {
  direction: rtl;
}
.countdown_holding span {
  color: #6b6b6b;
}
.countdown_row {
  clear: both;
  width: 100%;
  padding: 0px 2px;
  text-align: center;
}
.countdown_show1 .countdown_section {
  width: 98%;
}
.countdown_show2 .countdown_section {
  width: 48%;
}
.countdown_show3 .countdown_section {
  width: 32.5%;
}
.countdown_show4 .countdown_section {
  width: 24.5%;
}
.countdown_show5 .countdown_section {
  width: 19.5%;
}
.countdown_show6 .countdown_section {
  width: 16.25%;
}
.countdown_show7 .countdown_section {
  width: 14%;
}
.countdown_section {
  display: block;
  float: left;
  font-size: 100%;
  text-align: center;
}
.countdown_amount {
  font-size: 200%;
  font-weight: normal;
}
.countdown_descr {
  display: block;
  width: 100%;
}

@media screen and (max-width: 640px) {
  .wrap {
    display: block;
    width: 100%;
    margin: 0 0 10px;
    padding: 30px 0 0;
    text-align: left;
    overflow: hidden;
    border-radius: 0 !important;
    box-shadow: none !important;
  }
  .loading {
    margin-bottom: 20px;
  }
  .header,
  .content-wrap {
    width: 100%;
    clear: both;
    float: left;
    border-radius: 0;
    box-shadow: none;
  }

  .wrap-old {
    display: block;
    width: 100%;
    margin: 30px 0 0;
    padding: 0;
    text-align: left;
    overflow: hidden;
    border-radius: 0 !important;
    box-shadow: none !important;
  }
  .wrap-old .header,
  .wrap-old .content-wrap {
    border-radius: 0;
    box-shadow: none;
  }
  .wrap-old .header .logo,
  .wrap-old .header .slogan-wrap,
  .wrap-old .header .slogan-wrap .slogan {
    width: 100%;
    text-align: center;
  }
  .wrap-old .header .logo img {
    margin: 20px 0;
  }
  .wrap-old .header .slogan-wrap .slogan {
    padding: 0 0 20px 0;
    margin: 0;
  }

  .text-wrap {
    float: left;
    clear: both;
    width: 90% !important;
    margin: 0 5% 20px 5%;
    padding: 0;
    font-size: 16px;
  }
  .text-wrap-end {
    margin-bottom: 0;
  }
  .button {
    display: block;
    float: left;
    clear: both;
    width: 75%;
    margin-left: 5%;
    margin-right: 5%;
    font-size: 16px;
  }
  .button input {
    min-height: 48px;
    font-size: 16px;
  }
  .button input.button-half {
    display: block;
    width: 100%;
  }
  .button input.button-half:last-child {
    margin-top: 20px;
  }
  .device-info {
    float: left;
    width: 90%;
    margin: 20px 5% 0 5%;
    padding: 10px 0 0 0;
    border-top: 1px solid #dcdcdc;
    text-align: center;
    font-size: 16px;
  }
  .support-info {
    float: right;
    width: 90%;
    margin: 0 5% 20px 5%;
    padding: 10px 0 0 0;
    border-top: none;
    text-align: center;
    font-size: 16px;
  }
  .errors {
    display: block;
    width: 90%;
    margin: 0 5% 20px 5%;
    padding-left: 0;
    list-style: disc inside;
    font-size: 16px;
  }
  .errors li {
    margin: 0 10px 20px 10px;
  }
  .errors li:last-child {
    margin-bottom: 0;
  }
  .text {
    width: 90%;
    font-size: 16px;
    padding: 10px 5%;
  }
  .mini {
    width: 60px;
  }
  .rate_plan {
    display: block;
    width: 100%;
    font-size: 16px;
    padding: 10px 0;
    margin: 0;
    line-height: 20px;
  }
  h3 {
    clear: both;
    display: block;
    width: 90%;
    margin: 0 5% 20px 5%;
    padding-top: 20px;
    font-size: 20px;
  }
  #timeRemaining {
    display: block;
    width: 90%;
    margin: 0 5%;
    height: 30px;
    padding: 25px 0 20px;
    font-size: 120%;
  }
  .rate-plan {
    width: 90%;
    margin: 0 5% 20px;
    font-size: 16px;
  }
  #table-upgrade {
    width: 90%;
    margin: 0 5% 20px;
    font-size: 14px;
  }
  #table-devices tr td {
    padding: 10px;
  }
  .toc-agree {
    font-size: 12px;
  }
}
html {
  color: white;
  background-color: black;
}
body {
  background-color: black;
  color: white;
  font-size: 16px;
  line-height: 1.25rem !important;
}
p {
  color: white;
  font-size: 1rem;
}
a:link,
a:visited {
  color: white;
}
table,
tr,
td {
  padding: 0 !important;
  margin: 0 auto !important;
}
/*.loading { background: url(images/loading.gif) top center no-repeat transparent; }*/
.wrap {
  height: 100%;
  background: black;
  border-radius: 0;
  padding: 0;
  box-shadow: none !important;
  text-align: center;
}
.header {
  background-color: black;
  float: none !important;
  height: 12.5rem;
  padding: 0;
  text-align: center;
}
.header .logo {
  height: 100%;
  width: auto;
  margin: 0 auto;
}
.header .logo img {
  margin: 2.5rem;
  height: 7.5rem;
}
.text {
  background: black;
  color: white;
}
.text-wrap {
  padding: 0 !important;
  margin: 0 !important;
  width: 100% !important;
}
.table {
  width: 75%;
}
.toc-input {
  text-align: center;
}
.toc-input {
  color: white;
}
.button {
  min-height: 48px;
  font-size: 16px;
  margin: 0 auto !important;
  float: none !important;
}
.button input,
#tocButton {
  background: black;
  border: 1px solid white;
  color: white;
  cursor: pointer;
}
.button input:hover {
  background: black;
  color: white;
}
.button input:disabled {
  color: #999;
  border: 1px solid #999;
}
.button input:disabled:hover {
  background: #202020;
}
#timeRemaining {
  border-radius: 0;
}
.hasCountdown {
  background-color: #000;
  color: #fff;
}
</style>
